/** Achievement definitions and gamification settings helpers (client + server). */

export const ACHIEVEMENTS = [
  {
    id: "first_completion",
    title: "Первый шаг",
    description: "Завершите первую сессию обучения",
    icon: "🎯",
  },
  {
    id: "perfect_score",
    title: "Без ошибок",
    description: "100% правильных ответов в сессии (от 3 вопросов)",
    icon: "💯",
  },
  {
    id: "five_sessions",
    title: "Пятёрка",
    description: "5 завершённых сессий",
    icon: "⭐",
  },
  {
    id: "ten_sessions",
    title: "Десяточка",
    description: "10 завершённых сессий",
    icon: "🌟",
  },
  {
    id: "streak_3",
    title: "Огонёк",
    description: "3 дня обучения подряд",
    icon: "🔥",
  },
  {
    id: "streak_7",
    title: "Неделя силы",
    description: "7 дней обучения подряд",
    icon: "🔥",
  },
  {
    id: "streak_30",
    title: "Марафонец",
    description: "30 дней обучения подряд",
    icon: "🏅",
  },
  {
    id: "explorer",
    title: "Исследователь",
    description: "Пройдите 3 разных проекта",
    icon: "🧭",
  },
  {
    id: "path_master",
    title: "Мастер пути",
    description: "Пройдите сценарий, тренажёр и базу знаний",
    icon: "🎓",
  },
];

export const DEFAULT_GAMIFICATION = {
  enabled: true,
  xpPerCorrect: 10,
  xpCompletionBonus: 50,
  xpScenarioComplete: 30,
  showLeaderboard: true,
  showAchievements: true,
  showStreaks: true,
  certificateEnabled: true,
  certificateText:
    "🎓 Сертификат\n\n{name} успешно завершил(а) «{title}»\n\nРезультат: {score}\nМесто в рейтинге: {rank} из {total}\nУровень: {level} · XP: {xp}\n\n{date}",
  monthlyChallenge: {
    enabled: false,
    prizeText: "",
    targetCompletions: 5,
  },
};

export function readGamificationFromSettings(gameSettings = {}) {
  const raw = gameSettings.gamification ?? {};
  return {
    ...DEFAULT_GAMIFICATION,
    ...raw,
    monthlyChallenge: {
      ...DEFAULT_GAMIFICATION.monthlyChallenge,
      ...(raw.monthlyChallenge ?? {}),
    },
  };
}

export function mergeGamificationIntoSettings(existingSettings = {}, patch = {}) {
  const current = readGamificationFromSettings(existingSettings);
  const gamificationPatch = patch.gamification ?? patch;
  return {
    ...existingSettings,
    gamification: {
      ...current,
      ...gamificationPatch,
      monthlyChallenge: {
        ...current.monthlyChallenge,
        ...(gamificationPatch.monthlyChallenge ?? {}),
      },
    },
  };
}

export function xpToLevel(xp = 0) {
  return Math.max(1, Math.floor(Math.sqrt(Number(xp) / 50)) + 1);
}

export function getAchievementById(id) {
  return ACHIEVEMENTS.find((item) => item.id === id);
}

export function formatAccuracy(correct, total) {
  if (!total) return "—";
  return `${Math.round((correct / total) * 100)}%`;
}
